
import { mapState, mapActions, mapGetters } from "vuex";
import confirmationDialog from "../dialogs/confirmation-dialog.vue";
import CreateComboDialog from "../dialogs/menu-create-combo-dialog.vue";
import MenuUploadInfoDialog from "../dialogs/menu-upload-info-dialog.vue";
import RemoveModifyItemTile from "./remove-modify-item-tile.vue";
export default {
  components: {
    confirmationDialog,
    CreateComboDialog,
    RemoveModifyItemTile,
    MenuUploadInfoDialog
  },

  data() {
    return {
      deleteLoading: false,
      showDeleteConfirmationDialog: false,
      showEditComboDialog: false,
      showItemActiveWarningDialog: false
    };
  },
  props: {
    combo: {},
    item: {
      defaault: () => {},
      type: Object
    }
  },
  computed: {
    ...mapGetters("restaurant", ["getChannelNames"])
  },
  methods: {
    ...mapActions("menu", ["deleteCombo", "getCombosList"]),
    handleComboDeletion() {
      if (this.combo.is_active || this.combo.pending_availability_sync) {
        this.showItemActiveWarningDialog = true;
      } else {
        this.showDeleteConfirmationDialog = true;
      }
    },
    async handleDeleteCombo() {
      this.deleteLoading = true;
      try {
        await this.deleteCombo(this.combo.id);
        this.$nuxt.$emit("show-toast", {
          text: "Combo deleted successfully",
          color: "success darken-2",
          icon: "done",
          flat: true
        });
        this.getCombosList(true);
        this.showDeleteConfirmationDialog = false;
        if (!this.$vuetify.breakpoint.mdAndUp) {
          this.$emit("close-edit-modify-dialog");
        }
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
      }
      this.deleteLoading = false;
    }
  }
};
